<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                  >
                    <el-input
                      v-model="viewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                  >
                    <el-input
                      v-model="viewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="区县"
                  >
                    <el-input
                      v-model="viewForm.countyName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="零售户"
                  >
                    <el-input
                      v-model="viewForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="档位"
                  >
                    <el-input
                      v-model="viewForm.levelName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="到货周期"
                  >
                    <el-input
                      v-model="viewForm.receiptDayStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="采集人"
                  >
                    <el-input
                      v-model="viewForm.collectionUserName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="本周期到货日期"
                  >
                    <el-input
                      v-model="viewForm.periodReceiptDateStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="采集日期"
                  >
                    <el-input
                      v-model="viewForm.collectionDateStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="采集方式"
                  >
                    <el-input
                      v-model="viewForm.collectionTypeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="本周总销售(条)"
                  >
                    <el-input
                      v-model="viewForm.weekSalesAmount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="当前总库存(条)"
                  >
                    <el-input
                      v-model="viewForm.inventoryAmount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="云产烟总销售(条)"
                  >
                    <el-input
                      v-model="viewForm.yunWeekSalesAmount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="云产烟总库存(条)"
                  >
                    <el-input
                      v-model="viewForm.yunInventoryAmount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              采集信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="品规"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.productName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="本周期到货(条)"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.orderAmount"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'orderAmount')}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="当前库存(条)"
                    prop="inventoryAmount"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.inventoryAmount"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'inventoryAmount')}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="本码出货价"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.codeSalesPrice"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'codeSalesPrice')}"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
import { initStoreApi } from '@/api/store'
import { initRetailSurveyItemApi, saveOrUpdateRetailSurveyItemApi } from '@/api/retailSurveyInfo'
export default {
  components: { },
  mixins: [dialogDragMixin,setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      viewForm: {},
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        inventoryAmount: [ { required: true, message: '请输入库存', trigger: 'blur' }]
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.viewForm = {
          provinceName: '',
          cityName: '',
          countyName: '',
          storeName: '',
          receiptDayStr: '',
          collectionUserName: '',
          levelName: '',
          periodReceiptDateStr: '',
          collectionDateStr: '',
          collectionTypeStr: '',
          weekSalesAmount: null,
          inventoryAmount: null,
          yunWeekSalesAmount: null,
          yunInventoryAmount: null
        }
        this.dialogAddEditViewForm = {
          id: '',
          productName: '',
          orderAmount: '',
          inventoryAmount: '',
          codeSalesPrice: ''
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initRetailSurveyItemApi({ id: this.dataId }).then(res => {
        const { bill, item } = res.data
        for(let key in this.viewForm) {
            this.viewForm[key] = bill[key]
        }
        for(let key in this.dialogAddEditViewForm) {
            this.dialogAddEditViewForm[key] = item[key]
        }
        initStoreApi({id: bill.storeId}).then(res1 => {
          this.viewForm.provinceName = res1.data.provinceName
          this.viewForm.cityName = res1.data.cityName
          this.viewForm.countyName = res1.data.countyName
          this.viewForm.storeName = res1.data.storeName
        })
        this.dialogAddEditViewForm.id = item.id
        this.loading = false
      })
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '零售监测明细信息','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateRetailSurveyItemApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>

</style>
